import { AllowChangeGrid } from '../../../../../services/modules/product-colors-packs/product-colors-packs.types';
import { MediaType } from '../../../../../types/general.types';
import { AvailabilityEnum } from '../../../../products/ProductTypes';
import { isPreOrder } from '../../../../products/utils/availability.utils';

const OFFLINE_PRE_ORDER_PACKS_KEY = 'preOrderPacks';
const OFFLINE_IMMEDIATE_PACKS_KEY = 'immediatePacks';

export interface OfflineDatabaseProductColor {
  id: string;
  colorId: string;
  productId: string;
  code: string;
  name: string;
  isImage: boolean;
  allowChangePreOrderGrid: AllowChangeGrid;
  allowChangeImmediateGrid: AllowChangeGrid;
  allowPackPartialApplyInPreOrder: boolean;
  allowPackPartialApplyInImmediate: boolean;
  availabilities: AvailabilityEnum[];
  medias: OfflineProductColorMedia[];
  referenceColorIds: string[];
  deliveryWindowIds: { preOrder: string[]; futureStock: string[] };
  classificationIds: string[];
  [OFFLINE_PRE_ORDER_PACKS_KEY]?: OfflineProductColorPack[];
  [OFFLINE_IMMEDIATE_PACKS_KEY]?: OfflineProductColorPack[];
  hexcode?: string;
  imageUrl?: string;
}

export interface OfflineProductColorPack {
  id: string;
  packId: string;
  willConsumeStock: boolean;
  stock: {
    totalAmount: number;
    availableAmount: number;
  };
}

interface OfflineProductColorMedia {
  id: string;
  url: string;
  type: MediaType;
  position: number;
}

export const getOfflineProductColorPacksBasedOnAvailability = (
  productColor: OfflineDatabaseProductColor,
  availability: AvailabilityEnum,
): OfflineProductColorPack[] => {
  const key = isPreOrder(availability) ? OFFLINE_PRE_ORDER_PACKS_KEY : OFFLINE_IMMEDIATE_PACKS_KEY;

  const packs = productColor[key] || [];

  return packs;
};
